import * as React from "react";
import { Box, Button, Grid, Stack, Typography, useTheme } from "@mui/material";
import route from "../../../utils/Routes";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../../context/AuthContext";
import constants from "../../../utils/Constants";
import { Add } from "@mui/icons-material";
import { useQuery } from "react-query";
import { getCompaniesServ } from "../../../services/com-service";
import QueryKey from "../../../utils/QueryKey";
import { useEffect } from "react";
import { customAlert } from "../../../components/notify";
import ScrollBox from "../../../components/ScrollBox";
import ComCard1 from "../../../components/ComCard1";



function CompanyList({ type = "info" }) {
    const theme = useTheme();
    const navigate = useNavigate();
    const { setLoadingScreen, ctxtUser } = useAuthContext();
    const { isLoading, isError, error, data: comArr } = useQuery([QueryKey.comList],
        () => getCompaniesServ(ctxtUser?.userType, ctxtUser?.userId), {
        refetchOnMount: true,
        refetchOnWindowFocus: false
    });

    useEffect(() => {
        setLoadingScreen(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    function handleAddComClick() {
        navigate(route.aCreateCom);
    };

    function handleComCardClick(i) {
        if (type === "info")
            navigate(`${route.aCompany}/?comId=${i?.id}`)
        else
            navigate(`${route.aPoTracking}/?comId=${i?.id}`)
    }

    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }


    return (
        <Box height={"100%"} width={"100%"}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1, mt: 1 }} width={"100%"}>
                <Typography sx={{ fontSize: 18, fontWeight: 500, }}>{type === "info" ? 'Company List' : "Select Company"}</Typography>
                {(ctxtUser?.userType === constants.admin && type === "info") && <Button variant='outlined' startIcon={<Add />} onClick={handleAddComClick} sx={{
                    color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30
                }}>  Create Company</Button>}

            </Stack>
            <ScrollBox height={"84%"}>
                <Grid container spacing={3}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    {(comArr ?? []).map((i, index) => <Grid item xs="auto" key={index}>
                        <ComCard1 i={i} handleClick={handleComCardClick} /> </Grid>)}
                </Grid>
            </ScrollBox>
        </Box>
    );
}

export default CompanyList;